import appConstants from "../../sp-utils/app.constants";
import appUtils from "../../sp-utils/app.utils";
import wFActionConstants from "../../sp-utils/wfaction-constants";

const TaskService = () => {
  let service = {};

  // ----------------------------------------------------------------------------------------------------------------------------------
  /**
   * Fetch task list
   * @param {*} searchOptions
   * @param {*} pagingOptions
   * @param {*} sortingOptions
   * @param {*} successCB
   * @param {*} errorCB
   */
  service.upcomingTaskList = (searchOptions, pagingOptions, sortingOptions, successCB, errorCB) => {
    console.log("pagingOptions", pagingOptions);
    var options = {
      url: appConstants.spWSProtectedBaseUrl + appConstants.spWSPaths.task.list,
      data: {
        searchText: searchOptions.searchText,
        pageSize: pagingOptions.pageSize,
        pageNumber: pagingOptions.pageNumber,
        sortByColumnName: sortingOptions.sortByColumnName,
        sortByOrder: sortingOptions.sortByOrder,
      },
    };
    appUtils.callWebService(options, successCB, errorCB);
  };

  // ----------------------------------------------------------------------------------------------------------------------------------
  /**
   * Fetch task list
   * @param {*} searchOptions
   * @param {*} pagingOptions
   * @param {*} sortingOptions
   * @param {*} successCB
   * @param {*} errorCB
   */
  service.allTaskList = (searchOptions, pagingOptions, sortingOptions, successCB, errorCB) => {
    console.log("service", searchOptions);
    var options = {
      url: appConstants.spWSProtectedBaseUrl + appConstants.spWSPaths.task.all,
      data: {
        searchText: searchOptions.searchText,
        frDate: new Date(searchOptions.fromDate).getTime(),
        tdDate: new Date(searchOptions.toDate).getTime(),
        dateTypeCodeID: searchOptions.dateType,
        entityID: searchOptions.entity ? searchOptions.entity.entityID : null,
        statusCodeID: searchOptions.taskStatus ? searchOptions.taskStatus.codeID : null,
        pageSize: pagingOptions.pageSize,
        pageNumber: pagingOptions.pageNumber,
        sortByColumnName: sortingOptions.sortByColumnName,
        sortByOrder: sortingOptions.sortByColumnOrder,
      },
    };
    appUtils.callWebService(options, successCB, errorCB);
  };

  // ----------------------------------------------------------------------------------------------------------------------------------
  /**
   * Get task details
   * @param {*} taskNumber
   * @param {*} successCB
   * @param {*} errorCB
   */
  service.getTaskDetails = (taskNumber, successCB, errorCB) => {
    var url = appConstants.spWSProtectedBaseUrl + appConstants.spWSPaths.task.details;

    // Build the URL with appropriate email ID
    url = url.replace(":taskNumber", taskNumber);

    var options = {
      method: "GET",
      url: url,
    };

    appUtils.callWebService(options, successCB, errorCB);
  };

  // ----------------------------------------------------------------------------------------------------------------------------------
  /**
   * save task data
   *
   * @param {int} taskID - task ID
   *
   * @param {object} taskData - Object containing task data
   *
   * @param {successCallback} successCB - The callback function to be called on success
   *
   * @param {errorCallback} errorCB - The callback function to be called on error
   * */
  service.taskDataSave = function (taskID, taskData, successCB, errorCB) {
    const data = {
      taskID: taskID,
      dataValue: taskData.dataValue,
      entityWFStepDataID: taskData.entitytWFStepDataID,
    };

    if (taskData.taskDataID && taskData.taskDataID > 0) {
      data.taskDataID = taskData.taskDataID;
    }

    var options = {
      url: appConstants.spWSProtectedBaseUrl + appConstants.spWSPaths.taskData.save,
      data: data,
    };

    appUtils.callWebService(options, successCB, errorCB);
  };

  /**
   * Download task doc
   * @param {*} taskDataID
   * @param {*} successCB
   * @param {*} errorCB
   */
  service.downloadTaskDocument = function (taskDataID, successCB, errorCB) {
    var options = {
      url: appConstants.spWSProtectedBaseUrl + appConstants.spWSPaths.taskData.download.replace(":taskDataID", taskDataID),
      method: "GET",
    };

    appUtils.callWebService(options, successCB, errorCB);
  };

  // ----------------------------------------------------------------------------------------------------------------------------------
  /**
   * save task action
   *
   * @param {object} taskAction - Object containing the action details
   *
   * @param {successCallback} successCB - The callback function to be called on success
   *
   * @param {errorCallback} errorCB - The callback function to be called on error
   * */
  service.taskActionSave = function (taskAction, successCB, errorCB) {
    const data = {
      taskID: taskAction.taskID,
      actionCodeID: taskAction.actionCodeID,
      comment: taskAction.comment,
      reasonCodeIDs: taskAction.reasonCodeIDs,
      actionDate: taskAction.actionDate,
    };

    var options = {
      url: appConstants.spWSProtectedBaseUrl + appConstants.spWSPaths.taskAction.save,
      data: data,
    };

    appUtils.callWebService(options, successCB, errorCB);
  };

  // ----------------------------------------------------------------------------------------------------------------------------------
  /**
   * Get task percentage, based on current status
   * @param {*} task
   * @returns
   */
  service.getTaskProgressPercentage = (task) => {
    let totalSteps = 3;
    if (task.latestAction.codeID == appConstants.taskAction.created || task.latestAction.codeID == appConstants.taskAction.rejected)
      return 0;

    const stepNo = wFActionConstants.actionProgress.find((row) => row.actionCodeID == task.latestAction.codeID).stepsDone;

    if (task.approvalTypeCodeID == appConstants.approvalType.mandatory) {
      totalSteps = 4;
    }

    // when status = complied/complied with exp. and approver is not needed, step no will be > total steps
    if (stepNo > totalSteps) return 100;

    return (100 * stepNo) / totalSteps;
  };

  /**
   * Is task overdue
   * @param {*} task
   * @returns
   */
  service.isTaskOverdue = (task) => {
    return wFActionConstants.endState.indexOf(task.latestAction.codeID) == -1 && task.dueDate < Date.now();
  };

  /**
   * Is task not complied
   * @param {*} task
   * @returns
   */
  service.isTaskNotComplied = (task) => {
    return wFActionConstants.endState.indexOf(task.latestAction.codeID) == -1 && task.complianceDate < Date.now();
  };

  service.getFormattedTaskNumber = (taskNumber) => {
    return "EQ-" + taskNumber + " ";
  };

  // ----------------------------------------------------------------------------------------------------------------------------------
  /**
   * save task files
   *
   * @param {int} taskID - task ID
   *
   * @param {object} taskData - List containing multiple task files data
   *
   * @param {int} entityWFStepDataID - entityWFStepData ID
   *
   * @param {successCallback} successCB - The callback function to be called on success
   *
   * @param {errorCallback} errorCB - The callback function to be called on error
   * */
  service.taskFilesSave = function (taskData, taskID, entityWFStepDataID, successCB, errorCB) {
    const data = {
      taskID: taskID,
      entityWFStepDataID: entityWFStepDataID,
      taskDTOList: taskData,
    };

    var options = {
      url: appConstants.spWSProtectedBaseUrl + appConstants.spWSPaths.taskData.saveFiles,
      data: data,
    };

    appUtils.callWebService(options, successCB, errorCB);
  };

  // ----------------------------------------------------------------------------------------------------------------------------------
  /**
   * save task data
   *
   * @param {object} taskData - Object containing task file data
   *
   * @param {successCallback} successCB - The callback function to be called on success
   *
   * @param {errorCallback} errorCB - The callback function to be called on error
   * */
  service.taskFileDelete = function (taskData, successCB, errorCB) {
    const data = {
      taskID: taskData.taskID,
      dataValue: taskData.dataValue,
      entityWFStepDataID: taskData.entityWFStepDataID,
      taskDataID: taskData.taskDataID,
    };
    var url = appConstants.spWSProtectedBaseUrl + appConstants.spWSPaths.taskData.deleteFile,
      url = url.replace(":taskDataID", taskData.taskDataID);

    var options = {
      method: "DELETE",
      url: url,
      data: data,
    };
    appUtils.callWebService(options, successCB, errorCB);
  };

  service.taskCreate = function (postData, successCB, errorCB) {
    const complianceDate = new Date(postData.complianceDate);
    complianceDate.setDate(complianceDate.getDate() + 1);
    postData.complianceDate = complianceDate;

    var options = {
      url: appConstants.spWSProtectedBaseUrl + appConstants.spWSPaths.task.create,
      data: postData,
    };

    appUtils.callWebService(options, successCB, errorCB);
  };

  service.getStatusLocale = () => {
    const taskStatusLocale = {};
    ((taskStatusLocale["wFAction.report.10901"] = "Open"),
      (taskStatusLocale["wFAction.report.10902"] = "Pending For Approval"),
      (taskStatusLocale["wFAction.report.10903"] = "Approved"),
      (taskStatusLocale["wFAction.report.10904"] = "Rejected"),
      (taskStatusLocale["wFAction.report.10905"] = "Cancelled"),
      (taskStatusLocale["wFAction.report.10906"] = "Done With Exceptions"),
      (taskStatusLocale["wFAction.report.10907"] = "Approved"),
      (taskStatusLocale["wFAction.report.10908"] = "Closed"),
      (taskStatusLocale["wFAction.report.10909"] = "Partially Complied"),
      (taskStatusLocale["wFAction.report.10910"] = "Re-scheduled"));

    return taskStatusLocale;
  };

  // ----------------------------------------------------------------------------------------------------------------------------------
  /**
   * Fetch task report list —  url/params supplied by caller
   * @param {*} url
   * @param {*} searchParams
   * @param {*} pagingOptions
   * @param {*} sortingOptions
   * @param {*} successCB
   * @param {*} errorCB
   */
  service.taskReportList = (api, searchParams, pagingOptions, sortingOptions, successCB, errorCB) => {
    var options = {
      url: appConstants.spWSProtectedBaseUrl + api,
      data: {
        ...searchParams,
        pageSize: pagingOptions.pageSize,
        pageNumber: pagingOptions.pageNumber,
        sortByColumnName: sortingOptions.sortByColumnName,
        sortByOrder: sortingOptions.sortByOrder,
      },
    };
    appUtils.callWebService(options, successCB, errorCB);
  };

  service.dataMigrationExport = (searchOptions, successCB, errorCB) => {
    const fromDate = new Date(searchOptions.reportDates[0]).getTime();
    const toDate = new Date(searchOptions.reportDates[1]).getTime();
    var options = {
      url: appConstants.spWSProtectedBaseUrl + appConstants.spWSPaths.entityCompliance.dataMigrationExport,

      data: {
        forPeriodFromDate: fromDate,
        forPeriodToDate: toDate,
        entityIDList: searchOptions.entityIDList,
        complianceIDList: searchOptions.complianceIDList,
      },
    };
    appUtils.callWebService(options, successCB, errorCB);
  };

  return service;
};
export default TaskService();
